import { render } from "./ThanksPage.vue?vue&type=template&id=30a587a1&scoped=true"
import script from "./ThanksPage.vue?vue&type=script&lang=js"
export * from "./ThanksPage.vue?vue&type=script&lang=js"

import "./ThanksPage.vue?vue&type=style&index=0&id=30a587a1&scoped=true&lang=scss"

import exportComponent from "/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30a587a1"]])

export default __exports__